export enum AuditType {
    BHP = 'BHP',
    QUALITY = 'QUALITY',
    OTHER = 'OTHER',
}

export enum AuditShift {
    MORNING = 'MORNING',
    EVENING = 'EVENING',
    NIGHT = 'NIGHT',
}

export enum AuditReportPenaltyType {
    WORKER = 'WORKER',
    COORDINATOR = 'COORDINATOR',
    TEAM_LEADER = 'TEAM_LEADER',
}

export enum AuditIncompatibilityActionType {
    IMMEDIATE = 'IMMEDIATE',
    CORRECTIVE = 'CORRECTIVE',
    PERFECTING = 'PERFECTING',
}

export enum AuditIncompatibilitySource {
    MANUAL = 'MANUAL',
    NEGATIVE_AUDIT = 'NEGATIVE_AUDIT',
}

export enum AuditIncompatibilityStatus {
    PENDING = '0',
    RESOLVED = '1',
}

export const ActionTypes = [
    AuditIncompatibilityActionType.IMMEDIATE,
    AuditIncompatibilityActionType.PERFECTING,
    AuditIncompatibilityActionType.CORRECTIVE,
];